const projects = [
  {
    nom: "Kasa",
    technologies: ["reactJS", "NodeJS", "Express", "MongoDB"],
    img: "/media/Kasa.jpg",
    lien: "https://projet-kasa01.netlify.app/",
    description:
    "Un site de logement comme airbnb fait avec react a l'aide d'une api crée avec node js et une base de donné en non sql avec MongoDB",
  },
  {
    nom: "Apple music",
    technologies: ["Html", "Css"],
    img: "/media/Apple.jpg",
    lien: "https://page-apple-music.netlify.app/",
    description:
      "Une page Apple music fait avec avec html css.",
  },
  {
    nom: "souscription",
    technologies: ["Html", "Css"],
    img: "/media/Souscription.jpg",
    lien: "https://souscriptions.netlify.app/",
    description:
      "Une page de souscription d'abonnement fait avec avec html css.",
  },
  {
    nom: "souscription",
    technologies: ["Html", "Css"],
    img: "/media/Souscription.jpg",
    lien: "https://souscriptions.netlify.app/",
    description:
      "Une page de souscription d'abonnement fait avec avec html css.",
  },
];


export default projects;
